import axios from "axios";

class Support {
  constructor(element) {
    if (!element) return;

    this.elements = {
      parent: element,
      form: element.querySelector('form'),
      fields: element.querySelectorAll('input'),
      buttons: element.querySelectorAll('button[type="submit"]'),
      message: element.querySelector('.js-support-message'),
      amountRadios: element.querySelectorAll('.js-support-amount-radio'),
      otherAmount: element.querySelector('.js-support-other-amount'),
      otherAmountInput: element.querySelector('.js-support-other-amount-input'),
      loginForm: element.querySelector('.support-payment-type-subscription'),
      paymentType: element.querySelectorAll('.payment-type'),
      loginInputs: element.querySelectorAll('.login-inputs'),
      simpleDetails: element.querySelector('.simple-user-details'),
      paypalBtn: element.querySelector('.paypal-standard'),
      payuStandardBtn: element.querySelector('.payu-standard'),
      payuRecurringBtn: element.querySelector('.payu-recurring'),
      customAmountBtn: element.querySelector('.custom-amount-btn'),
      simpleDetailsInputs: element.querySelectorAll('.simple-details-inputs'),
      requiredFields: element.querySelector('.js-required-fields'),
    }

    this.settings = {
      ajaxURL: support_vars.ajaxUrl,
      wpNonce: support_vars.wpNonce,
      action: support_vars.action,
      requiredMessage: support_vars.requiredMessage,
      emailMessage: support_vars.emailMessage,
      numberMessage: support_vars.numberMessage,
    }

    this.state = {
      loading: false,
      error: false,
    }

    this.init();
  }

  setState(newState, refresh = true) {
    this.state = {
      ...this.state,
      ...newState,
    }

    if (refresh) {
      this.update();
    }
  }

  init() {
    const {
      form,
      buttons,
      otherAmount,
      otherAmountInput,
      amountRadios,
      paymentType,
      loginForm,
      loginInputs,
      simpleDetailsInputs,
      simpleDetails,
      paypalBtn,
      payuStandardBtn,
      payuRecurringBtn,
      customAmountBtn,
      requiredFields,
    } = this.elements;

    customAmountBtn.classList.add('hidden');
    // paypalBtn.classList.add('hidden');
    payuStandardBtn.classList.add('hidden');
    payuRecurringBtn.classList.remove('hidden');
    //setup default
    if (loginInputs.length > 0) {
      loginForm.classList.remove('hidden');
      simpleDetails.classList.add('hidden');


      loginInputs.forEach(function (input) {
        input.required = true;
      });
      simpleDetailsInputs.forEach(function (input) {
        input.required = false;
      });
    } else {
      requiredFields.classList.add('hidden');
    }

    //payment type bind
    paymentType.forEach(radio => {
      radio.addEventListener('change', e => {
        if (e.target.value === 'subscription') {
          // paypalBtn.classList.add('hidden');
          payuStandardBtn.classList.add('hidden');
          payuRecurringBtn.classList.remove('hidden');
          customAmountBtn.classList.add('hidden');

          otherAmount.classList.add('hidden');
          otherAmountInput.required = false;

          if (loginInputs.length > 0) {
            loginForm.classList.remove('hidden');
            simpleDetails.classList.add('hidden');

            loginInputs.forEach(function (input) {
              input.required = true;
            });
            simpleDetailsInputs.forEach(function (input) {
              input.required = false;
            });
          }

          const customRadio = [...amountRadios].find(radio => radio.value === 'custom');

          if (customRadio && customRadio.checked) {
            const radios = [...amountRadios].filter(radio => radio.value !== 'custom');

            if (radios.length > 0) {
              radios[0].checked = true;
            }
          }
        } else {
          // paypalBtn.classList.remove('hidden');
          payuStandardBtn.classList.remove('hidden');
          payuRecurringBtn.classList.add('hidden');
          customAmountBtn.classList.remove('hidden');

          const customRadio = [...amountRadios].find(radio => radio.value === 'custom');

          if (customRadio && customRadio.checked) {
            otherAmount.classList.remove('hidden');
            otherAmountInput.required = true;
          }

          if (simpleDetailsInputs.length > 0) {

            loginForm.classList.add('hidden');
            simpleDetails.classList.remove('hidden');

            simpleDetailsInputs.forEach(function (input) {
              input.required = true;
            });
            loginInputs.forEach(function (input) {
              input.required = false;
            });
          }
        }
      });
    });

    if (!form || buttons.length === 0) return;

    buttons.forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault();

        const paymentMethod = e.target.dataset.paymentMethod;

        if (this.validate() && !this.state.loading) {
          this.submit(paymentMethod);
        }
      });
    });

    if (amountRadios.length === 0 || !otherAmount || !otherAmountInput) return;

    amountRadios.forEach(radio => {
      radio.addEventListener('change', e => {
        if (e.target.value === 'custom') {
          otherAmount.classList.remove('hidden');
          otherAmountInput.required = true;
        } else {
          otherAmount.classList.add('hidden');
          otherAmountInput.required = false;
        }
      });
    });
  }

  getFormData(additionalFields = {}) {
    const formData = new FormData(this.elements.form);

    if (formData.get('payment-type') === null || formData.get('payment-type') === '') {
      formData.set('payment-type', 'simple');
    }

    for (const [key, value] of Object.entries(additionalFields)) {
      formData.append(key, value);
    }

    if (formData.get('amount') === "custom") {
      let customAmount = formData.get('custom-amount');
      formData.set('amount', customAmount);
      formData.delete('custom-amount');
    }

    return formData;
  }

  getErrorElement(message) {
    const element = document.createElement("div");
    element.classList.add('error');
    element.innerText = message;

    return element;
  }

  isEmail(email) {
    return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test(email);
  }

  validateRequiredField(field) {
    const {requiredMessage} = this.settings;

    if (field.hasAttribute('required') && field.value === "") {
      if (!field.classList.contains('is-not-valid')) {
        field.parentNode.append(this.getErrorElement(requiredMessage));
        field.classList.add('is-not-valid');
      }
      return false;
    } else {
      field.classList.remove('is-not-valid');
      const error = field.parentNode.querySelector('.error');
      if (error) {
        error.remove();
      }
    }

    return true;
  }

  validateRequiredCheckbox(field) {
    const {requiredMessage} = this.settings;

    if (field.hasAttribute('required') && field.checked === false) {
      if (!field.classList.contains('is-not-valid')) {
        field.parentNode.append(this.getErrorElement(requiredMessage));
        field.classList.add('is-not-valid');
      }
      return false;
    } else {
      field.classList.remove('is-not-valid');
      const error = field.parentNode.querySelector('.error');
      if (error) {
        error.remove();
      }
    }

    return true;
  }

  validateEmailField(field) {
    const {emailMessage} = this.settings;

    if (field.value !== "" && !this.isEmail(field.value)) {
      field.parentNode.append(this.getErrorElement(emailMessage));
      field.classList.add('is-not-valid');
      return false;
    } else {
      field.classList.remove('is-not-valid');
      const error = field.parentNode.querySelector('.error');
      if (error) {
        error.remove();
      }
    }
    return true;
  }

  validateNumberField(field, min = 1) {
    const {numberMessage} = this.settings;

    if (field.value !== "" && field.value < min) {
      field.parentNode.append(this.getErrorElement(numberMessage));
      field.classList.add('is-not-valid');
      return false;
    } else {
      field.classList.remove('is-not-valid');
      const error = field.parentNode.querySelector('.error');
      if (error) {
        error.remove();
      }
    }
    return true;
  }

  validate() {
    const {fields} = this.elements;
    var valid = true;

    if (fields.length === 0) return;

    fields.forEach(field => {
      if (this.validateRequiredField(field)) {
        if (field.type === "email") {
          if (!this.validateEmailField(field)) valid = false;
        }

        if (field.type === "number") {
          if (!this.validateNumberField(field)) valid = false;
        }
      } else {
        valid = false;
      }

      if (field.type === "checkbox") {
        if (!this.validateRequiredCheckbox(field)) valid = false;
      }
    });

    return valid;
  }

  async submit(paymentMethod) {
    this.setState({loading: true});
    try {
      const formData = this.getFormData({
        'action': this.settings.action,
        'wpNonce': this.settings.wpNonce,
        'paymentMethod': paymentMethod,
      });

      const response = await axios(this.settings.ajaxURL, {
        method: "post",
        data: formData,
        withCredentials: true
      });

      if (response.status === 200) {
        this.setState({sent: true, loading: false});
        this.successResult(response.data?.redirect);
      }
    } catch (error) {
      this.errorResult(error.response.data?.message);
      this.setState({loading: false, error: true});
    }
  }

  successResult(redirect) {
    window.location.assign(redirect);
  }

  errorResult(message = "") {
    this.elements.message.innerText = message;
    this.elements.message.classList.remove('hidden');
  }

  getLoader() {
    const loader = document.createElement('div');
    loader.classList.add('loader');
    const spinner = document.createElement('div');
    spinner.classList.add('spinner');
    loader.append(spinner);

    return loader;
  }

  update() {
    const {form} = this.elements;
    const loader = form.querySelector('.loader');

    if (this.state.loading) {
      form.classList.add('is-loading');

      if (!loader) {
        form.append(this.getLoader());
      }
    } else {
      form.classList.remove('is-loading');
      loader?.remove();
    }

    if (this.state.error) {
      form.classList.add('has-error');
    } else {
      form.classList.remove('has-error');
    }

    if (this.state.sent) {
      form.classList.add('was-sent');
    } else {
      form.classList.remove('was-sent');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.js-support');

  if (elements.length === 0) return;

  elements.forEach(element => {
    new Support(element);
  })
});
